import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronRight, Trophy } from 'lucide-react';
import { useLeaderboard } from 'modules/leaderboard';

/** One line on the home page: the learner's IELTS place this week, linking to the full board. */
export function LeaderboardCard() {
  const { t } = useTranslation();
  const { data } = useLeaderboard('IELTS');
  if (!data || (!data.entries.length && !data.me)) return null;
  const rank = data.me?.rank && !data.hidden ? data.me.rank : null;
  return (
    <Link
      to="/portal/leaderboard"
      className="flex items-center gap-3 rounded-lg border border-border bg-card px-5 py-3.5 transition-colors hover:bg-muted/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <Trophy className="h-5 w-5 shrink-0 text-amber-500" aria-hidden />
      <span className="min-w-0 flex-1 text-sm text-foreground">
        {rank ? t('leaderboard.home_rank', { rank }) : t('leaderboard.home_cta')}
      </span>
      <ChevronRight className="h-4 w-4 text-muted-foreground" aria-hidden />
    </Link>
  );
}

export default LeaderboardCard;
